import React, {startTransition, Suspense, useCallback, useContext, useEffect, useMemo, useState} from "react"
import  TopBar  from "./TopBar/TopBar"
import  Body  from "./Body/Body"
import Footer from "./Footer/Footer"
import "./HomeScreen.css"
import { AppContext } from "../../context/AppContext"
import { cityWithPreposition, Coordonates, Restaurant,slugify,faqBase, cityWithOtherPreposition , faqProx} from "../../components/types/types"
import logoWhiteHight from '../../image/logo/logoWhiteHight.webp'
import { Helmet } from 'react-helmet-async';
import MaskBackground from "../../components/maskBackground/maskBackground"
import { useParams } from "react-router-dom"
import { useNavigate,useLocation } from 'react-router-dom';


const ConnectionScreen = React.lazy(() => import("../ConnectionScreen/ConnectionScreen"));
const ShowAllCuisine = React.lazy(() => import("../../components/showAllFilters/showAllCuisine"));
const ShowAllType = React.lazy(() => import("../../components/showAllFilters/showAllType"));
const CantProximity = React.lazy(() => import("../../components/cantProximity/cantProximity"));

const fetchCityData = async (cityName: string) => {
  let data = null;
    try {
        const response = await fetch(`https://api-adresse.data.gouv.fr/search/?q=${cityName}&limit=10`);
        if (response.ok) return await response.json();
    } catch (err) {
        data = null;
    }
  if (!data || data === null) {
    try {
         const response = await fetch(`${process.env.REACT_APP_DIRECTION_REQUEST}/api/getListCity`, { 
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({cityName}),
        });
        if (response.ok) return await response.json();
    } catch (err) {
        data = null;
    }
  }
  return data;
};
const topCities = [
  { name: "Restaurants à Brissac-Loire-Aubance", url: "https://www.quelresto.fr/brissac-loire-aubance" },
  { name: "Restaurants à Mûrs-Erigné", url: "https://www.quelresto.fr/murs-erigne" },
  { name: "Restaurants aux Ponts-de-Cé", url: "https://www.quelresto.fr/les-ponts-de-ce" },
  { name: "Restaurants à Trélazé", url: "https://www.quelresto.fr/trelaze" },
];

const buildFaqLd = (listFaq:string[][],canonicalUrl:string) => {
  if (!listFaq || listFaq.length < 1) return null;
  return {
    "@type": "FAQPage",
    "@id": `${canonicalUrl}#faq`,
    "mainEntity": listFaq.map(( elem, a ) => ({
      "@type": "Question",
      "name": elem[0],
      "acceptedAnswer": { "@type": "Answer", "text": elem[1] }
    }))
  };
};
const HomeScreen = () => {
    const { setValueSearchCity,connectionScreen,searchCity,setSearchCity,coordonates,setAllPresentFilter,loadPage,setLoadPage,filterChoose,setLocations,setFilterChoose,setCoordonates} = useContext(AppContext)
    const [listeResto,setListeResto] = useState<Restaurant[]>([])
    const [fetchResto,setFetchResto] = useState(false)
    const [lengthResto,setLengthResto] = useState(0)
    const [showAll,setShowAll] = useState(0)
    const { city } = useParams<{ city?: string }>();
    const location = useLocation();
    const canonicalUrl = typeof window !== 'undefined'
    ? `${window.location.origin}${location.pathname}`
    : '';
    const itemListHome = {
        "@type": "ItemList",
        "name": "Villes populaires",
        "itemListElement": topCities.map((c, i) => ({
            "@type": "ListItem",
            "position": i + 1,
            "item": { "@type": "WebPage", "name": c.name, "url": c.url }
        }))
    };
    const homeWebPageLd = {
        "@type": "WebPage",
        "@id": "https://www.quelresto.fr/#webpage",
        "url": "https://www.quelresto.fr/",
        "name": "QuelResto – Les meilleurs restaurants à proximité – 2025",
        "inLanguage": "fr-FR",
        "isPartOf": { "@id": "https://www.quelresto.fr/#website" },
        "about": { "@id": "https://www.quelresto.fr/#organization" },
        "description": "Trouvez facilement les meilleurs restaurants à proximité : menus, photos, avis et infos pratiques. Avec QuelResto, vous pouvez enfin choisir vos restaurants simplement."
    }
    const homeLd = {
        "@context": "https://schema.org",
        "@graph": [homeWebPageLd,itemListHome,buildFaqLd(faqBase,canonicalUrl)]
    };
    const jsonLdProx = {
        "@context": "https://schema.org",
        "@graph": [{
            "@type": "WebPage",
            "@id": "https://www.quelresto.fr/restaurants-a-proximite#webpage",
            "name": "Les meilleurs restaurants à proximité",
            "description": "Restaurants à proximité : cartes, photos, horaires et adresses. Trouvez facilement un restaurant autour de vous.",
            "url": canonicalUrl,
            "isPartOf": { "@id": "https://www.quelresto.fr/#website" },
            "breadcrumb": { "@id": "https://www.quelresto.fr/restaurants-a-proximite#breadcrumb" }
        },
        {
            "@type": "BreadcrumbList",
            "@id": "https://www.quelresto.fr/restaurants-a-proximite#breadcrumb",
            "itemListElement": [
                { "@type": "ListItem", "position": 1, "name": "Accueil", "item":"https://www.quelresto.fr/" },
                { "@type": "ListItem", "position": 2, "name": "Restaurants à proximité", "item": canonicalUrl }
        ]},
        buildFaqLd(faqProx,canonicalUrl)
    ]}
    const [cityEntity,setCityEntity] = useState({})
    const [breadcrumbEntity,setBreadcrumbEntity] = useState({})
    const [finalCityLoad,setFinalCityLoad] = useState<string>(city ||'')
    const navigate = useNavigate();
    const [cantProximity,setCantProximity] = useState(false)

    
    useEffect(() => {
        if (!city) {
            fetchRestaurants()
            setFinalCityLoad(''); 
            return;
        }
        else if (city === 'restaurants-a-proximite') {
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(
                    (position) => {
                        const userLocation:Coordonates = {
                            latitude: position.coords.latitude.toString(),
                            longitude: position.coords.longitude.toString(),
                        };
                        setSearchCity("A proximité");
                        setValueSearchCity("A proximité")
                        setFinalCityLoad('à proximité')
                        setCoordonates(userLocation); 
                    },
                    (error) => {
                        fetchRestaurants()
                        setCantProximity(true)
                    }
                );
            } else {
                console.error("Geolocation n'est pas supportée par ce navigateur.");
                setSearchCity("");
            }
            return;
        }

        const validateCity = async (cityName: string) => {
            try {
                const data = await fetchCityData(cityName);
                if (data.features && data.features.length > 0) {
                    let properties = null;

                    for (const feature of data.features) {
                        const postcode = feature.properties?.postcode;
                        if (postcode && postcode.startsWith('49')) {
                            properties = feature.properties;
                            break;
                        }
                    }

                    const slugCity = slugify(properties.city)

                    const case1 = properties.city && (properties.score > 0.9 && cityName === slugCity);
                    const case2 = properties.city && (properties.score > 0.6 && properties.oldcity && cityName === slugify(properties.oldcity))

                    if (case1 || case2) {
                        const coords: Coordonates = {
                            latitude: data.features[0].geometry.coordinates[1],
                            longitude: data.features[0].geometry.coordinates[0],
                        };
                        let tempFinalCity = case2 ? properties.oldcity : properties.city;
                        setCoordonates(coords)
                        let cityPrep = cityWithPreposition(tempFinalCity)
                        setFinalCityLoad(cityPrep)
                        fetchRestaurantsWithCoords(coords)
                        setCityEntity({
                            "@type": "City",
                            "mainEntityOfPage": { "@id": `${canonicalUrl}#webpage` },
                            "@id": `${canonicalUrl}#city`,  
                            "name": tempFinalCity,
                            "address": {
                                "@type": "PostalAddress",
                                "addressLocality": tempFinalCity,
                                "addressRegion": "Pays de la Loire",
                                "addressCountry": "FR"
                            },
                            ...(coords && coords.latitude && coords.longitude ? {
                                "geo": {
                                "@type": "GeoCoordinates",
                                "latitude":  Number(coords.latitude),
                                "longitude":  Number(coords.longitude)
                                }
                            } : {})
                        });
                        setBreadcrumbEntity({
                            "@type":"BreadcrumbList",
                            "@id": `${canonicalUrl}#breadcrumb`,   
                            "itemListElement":[
                                { "@type":"ListItem", "position":1, "name":"Accueil", "item":"https://www.quelresto.fr/" },
                                { "@type":"ListItem", "position":2, "name":tempFinalCity, "item":canonicalUrl }
                            ]
                        })
                        setValueSearchCity(tempFinalCity)

                    } else if (properties.city && (properties.score > 0.6 && properties.oldcity) && cityName === slugCity) {
                        navigate('/' + slugify(properties.oldcity), { replace: true });
                    } else if (properties.city && properties.score > 0.5) {
                        navigate('/' + slugCity, { replace: true });
                    } else {
                        setFinalCityLoad(''); 
                        fetchRestaurants()
                        navigate('/', { replace: true });
                    }
                } else {
                    setFinalCityLoad(''); 
                    fetchRestaurants()
                    navigate('/', { replace: true });
                }
            } catch (error) {
                setFinalCityLoad(''); 
                fetchRestaurants()
                navigate('/', { replace: true });
            }
        };
        validateCity(city);

    }, [city]);

    const recupAllFilter = (list:Restaurant[]) => {
        const allFilters = new Set<string>();
        list.forEach((resto) => {
            resto.filters?.forEach((filtre) => allFilters.add(filtre));
            resto.cuisines.forEach((cuisine) => cuisine !== '' && allFilters.add(cuisine));
        });
        setAllPresentFilter(Array.from(allFilters));
    }
    const fetchRestaurants = async () => {
        try {
            const response = await fetch(`${process.env.REACT_APP_DIRECTION_REQUEST}/api/getResto`, { 
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
            });
            const data: Restaurant[] = await response.json();
            setListeResto(data);
            const newLocations = data.map((resto) => {
                const [lng, lat] = resto.location.coordinates;
                return {lat,lng, name: resto.name,idrestaurant: resto.idrestaurant,id_url:resto.id_url, devanture:resto.devanture,type:resto.type,note:resto.note,
                    address:resto.address,phone:resto.phone,listImg:resto.listimg ? resto.listimg : [],schedule:resto.schedule,date_update:resto.date_update,is_resa_phone:resto.is_resa_phone,
                    special_date : resto.special_date ? resto.special_date : {},biography: resto.biography,total_price:resto.total_price, cuisines: resto.cuisines, date_published: resto.date_published ? resto.date_published : null  };
            });
            setLocations(newLocations)
            recupAllFilter(data)
            setFetchResto(true)
        } catch (error) {
            console.error("Error fetching restaurant data:", error);
        }
    };
    const fetchRestaurantsWithCoords = async (coordsLoad?:Coordonates,city?:string) => {
        try {
            const response = await fetch(`${process.env.REACT_APP_DIRECTION_REQUEST}/api/getRestoCoords`, { 
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    latitude: coordsLoad?.latitude || coordonates.latitude,
                    longitude: coordsLoad?.longitude || coordonates.longitude,
                    ...(city ? {cityname:city} : {})
                }),
            });
            const data: Restaurant[] = await response.json();
            setListeResto(data);
           
            const newLocations = data.map((resto) => {
                
                const [lng, lat] = resto.location.coordinates;
                return {lat,lng, name: resto.name,idrestaurant: resto.idrestaurant,id_url:resto.id_url,devanture:resto.devanture,type:resto.type,note:resto.note,address:resto.address,
                    phone:resto.phone,listImg:resto.listimg ? resto.listimg : [],schedule:resto.schedule,date_update:resto.date_update,is_resa_phone:resto.is_resa_phone,
                    special_date : resto.special_date ? resto.special_date : {},biography: resto.biography,total_price:resto.total_price, cuisines: resto.cuisines , date_published: resto.date_published ? resto.date_published : null  };
            });
            setLocations(newLocations)
            recupAllFilter(data)
            setFetchResto(true)
        } catch (error) {
            console.error("Error fetching restaurant data:", error);
        }
    };
    const distanceFilter =  useCallback((distance:number) => {
        try {
            if (!navigator.geolocation) {
                alert("La géolocalisation n'est pas supportée par votre navigateur.");
                return;
            }
            navigator.geolocation.getCurrentPosition(

                async (position) => {
                    const newFilter = distance;
                    let updatedFilters = [...filterChoose];
                    const index = updatedFilters.findIndex(filter => typeof filter === "number");
                    if (index !== -1) updatedFilters[index] = newFilter;
                    else updatedFilters.push(newFilter);
                    startTransition(() => {
                        setFilterChoose(updatedFilters);
                    })
                    const { latitude, longitude } = position.coords;
                    const response = await fetch(`${process.env.REACT_APP_DIRECTION_REQUEST}/api/getRestoCoords`, { 
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({
                            latitude: latitude,
                            longitude: longitude,
                            distance:distance,
                        }),
                    });
                    const data: Restaurant[] = await response.json();
                    setListeResto(data);
                    const newLocations = data.map((resto) => {
                        const [lng, lat] = resto.location.coordinates;
                        return {lat,lng, name: resto.name,idrestaurant: resto.idrestaurant,id_url:resto.id_url,devanture:resto.devanture,type:resto.type,note:resto.note,
                            address:resto.address,phone:resto.phone,listImg:resto.listimg ? resto.listimg : [],schedule:resto.schedule,date_update:resto.date_update,is_resa_phone:resto.is_resa_phone,
                            special_date : resto.special_date ? resto.special_date : {},biography: resto.biography,total_price:resto.total_price, cuisines: resto.cuisines,date_published: resto.date_published ? resto.date_published : null   };
                    });
                    startTransition(() => {
                        setLocations(newLocations)
                        recupAllFilter(data)
                        setFetchResto(true)
                    })
                }, (error) => {
                    alert("La géolocalisation est désactivée ou non autorisée. Veuillez l'activer pour filtrer par distance.");
                }
                );
        } catch (error) {

            alert("La géolocalisation est désactivée ou non autorisée. Veuillez l'activer pour filtrer par distance.");
        }
    },[setFilterChoose, setLocations])
    useEffect(() => {
        setTimeout(() => {
            setLoadPage(true)
        },2300)
    },[])
    useEffect(() => {
        if(coordonates.latitude !== "" && coordonates.longitude !== "") {
            fetchRestaurantsWithCoords(undefined,searchCity);
        }
    },[searchCity])

    const funcClose = () => {
        setShowAll(0)
    }
    const priceRangeFromTotal = (p?: number) =>
        typeof p === "number"
            ? p <= 15 ? "€" : p <= 30 ? "€€" : p <= 60 ? "€€€" : "€€€€"
            : undefined;


    const itemListLd = useMemo(() => {
        if (!finalCityLoad || !Array.isArray(listeResto) || !listeResto.length || (finalCityLoad && finalCityLoad === 'à proximité')) return null;

        const origin = typeof window !== "undefined" ? window.location.origin : "https://www.quelresto.fr";
        const top = [...listeResto].slice(0, 10);

        const itemListElement = top.map((r, i) => {
            const citySlug = slugify(r.address?.[1] ?? finalCityLoad);
            const rUrl = `${origin}/restaurant/${citySlug}/${slugify(r.name)}_${r.id_url}`;
            const item: any = {
            "@type": "Restaurant",
            "@id": `${rUrl}#restaurant`,
            "name": r.name,
            "url": rUrl,
            };
            if (r.devanture) item.image = r.devanture;
            const pr = priceRangeFromTotal(r.total_price);
            if (pr) item.priceRange = pr;
            if ((r?.nbr_review ?? 0) > 0 && (r?.note ?? 0) > 0) {
            item.aggregateRating = {
                "@type": "AggregateRating",
                "ratingValue": Number(r.note),
                "reviewCount": Number(r.nbr_review),
                "bestRating": 5,
                "worstRating": 1
            };
            }
            if (r.address?.[1]) {
            item.address = {
                "@type": "PostalAddress",
                "addressLocality": r.address[1],
                ...(r.address?.[0] ? { "streetAddress": r.address[0] } : {}),
                "addressCountry": "FR"
            };
            }
            if (Array.isArray(r.cuisines) && r.cuisines.length) {
            item.servesCuisine = r.cuisines;
            }

            return {
            "@type": "ListItem",
            "position": i + 1,
            "item": item
            };
        });

        return {
            "@type": "ItemList",
            "@id": `${canonicalUrl}#list`,
            "name": `Restaurants ${finalCityLoad}`,
            "itemListOrder": "https://schema.org/ItemListOrderDescending",
            "numberOfItems": itemListElement.length,
            "itemListElement": itemListElement
        };
    }, [listeResto, finalCityLoad, canonicalUrl]);

    const collectionPageLd = useMemo(() => ({
        "@type": "CollectionPage",
        "@id": `${canonicalUrl}#webpage`,
        "url": canonicalUrl,
        "name": `Les meilleurs restaurants ${finalCityLoad} – QuelResto`,
        "inLanguage": "fr-FR",
        "isPartOf": { "@id": "https://www.quelresto.fr/#website" },
        "about": { "@id": `${canonicalUrl}#city` },
        "breadcrumb": { "@id": `${canonicalUrl}#breadcrumb` },
        "contentLocation": { "@id": `${canonicalUrl}#city` },
        "description": `Les meilleurs restaurants ${finalCityLoad} : menus, photos, avis, horaires et prix moyens. Contact direct des établissements — QuelResto.`,
        ...(itemListLd ? { "mainEntity": { "@id": `${canonicalUrl}#list` } } : {})
    }), [canonicalUrl, finalCityLoad, itemListLd]);

    const jsonLdVille = useMemo(() => ({
        "@context": "https://schema.org",
        "@graph": [
            cityEntity,
            collectionPageLd,
            breadcrumbEntity,
            ...(finalCityLoad ? [buildFaqLd([[`Comment trouver facilement un restaurant ${finalCityLoad} et ses alentours`,`Sur QuelResto, vous pouvez comparer facilement tous les restaurants ${finalCityLoad} grâce aux cartes, photos, horaires et avis disponibles sur chaque restaurants. Pour explorer aussi les restaurants à proximité ${cityWithOtherPreposition(finalCityLoad)}, utilisez les pages dédiées aux villes voisines ou naviguez dans la liste complète des établissements référencés.`],
                [`Où voir la carte, les photos et les avis des restaurants ${finalCityLoad}`,`Sur QuelResto, chaque restaurant ${finalCityLoad} dispose d’une page complète avec sa carte, ses photos, ses horaires et les avis clients. Vous pouvez ainsi comparer facilement les restaurants ${finalCityLoad} et choisir l’adresse qui correspond le mieux à vos envies.`],
                [`Comment trouver un restaurant pas cher, romantique, avec terrasse, concrètement un restaurant adapté à mes envies ou à mes besoins ${finalCityLoad}`,`QuelResto vous permet de filtrer les restaurants ${finalCityLoad} selon vos besoins et envies. Vous pouvez par exemple trouver un restaurant pas cher, un restaurant romantique, un restaurant avec terrasse, ou encore choisir selon le budget, l’ambiance, un régime alimentaire (végétarien, végan, halal, sans gluten) ou des options pratiques comme l’accessibilité PMR ou le parking. L’ensemble des filtres disponibles vous permet ainsi de comparer facilement les restaurants ${finalCityLoad} et de trouver l’adresse la plus adaptée à vos envies et à vos besoins.`],
                [`Peut-on réserver un restaurant en ligne ${finalCityLoad}`,`Sur chaque page restaurant ${finalCityLoad}, vous retrouvez une section réservation avec le numéro de téléphone du restaurant. Si l’établissement propose une réservation en ligne via son propre outil, un lien pour y accéder est affiché. À l’avenir, QuelResto intégrera sa propre réservation en ligne pour réserver rapidement et avoir des avis vérifiés. Vous pourrez ainsi réserver un restaurant ${finalCityLoad} en quelques clics, simplement et en toute confiance.`]],canonicalUrl)] : []),
            ...(itemListLd ? [itemListLd] : [])
        ]
    }), [cityEntity, collectionPageLd, breadcrumbEntity, itemListLd,finalCityLoad]);

    return (
        <>
        <Helmet>
            <link rel="canonical" href={canonicalUrl} />
            {finalCityLoad ? (
                finalCityLoad === "à proximité" ? 
                <>
                    <title>Les meilleurs restaurants à proximité</title>
                    <meta
                        name="description" 
                        content={`Restaurants à proximité : cartes, photos, horaires et adresses. Trouvez facilement un restaurant autour de vous.`}
                        />
                    <meta property="og:title" content={`Les meilleurs restaurants à proximité`} />
                    <meta property="og:description" content={`Restaurants à proximité : cartes, photos, horaires et adresses. Trouvez facilement un restaurant autour de vous.`} />
                    <meta property="og:url" content={canonicalUrl} />
                    <script type="application/ld+json">{JSON.stringify(jsonLdProx)}</script>
                </>
                :
                <>
                <title>{`Les meilleurs restaurants ${finalCityLoad}, Maine-et-Loire – 2025`}</title>
                <meta
                    name="description" 
                    content={`Restaurants ${finalCityLoad} (Maine-et-Loire) : cartes, photos, horaires et adresses. Trouvez facilement votre restaurant à proximité.`}
                    />
                <meta property="og:title" content={`Les meilleurs restaurants ${finalCityLoad}, Maine-et-Loire – 2025`} />
                <meta property="og:description" content={`Restaurants ${finalCityLoad} (Maine-et-Loire) : cartes, photos, horaires et adresses. Trouvez facilement votre restaurant à proximité.`} />
                <meta property="og:url" content={canonicalUrl} />
                <script type="application/ld+json">{JSON.stringify(jsonLdVille)}</script>
                </>) 
                : <>
                    <title>QuelResto – Les meilleurs restaurants à proximité – 2025</title>
                      <script type="application/ld+json">
                        {JSON.stringify(homeLd)}
                    </script>
                </>
            }
        </Helmet> 
        

        <div className='homeScreen'>

            {!loadPage && <div className='loadPage'>
                <img  src={logoWhiteHight} loading="lazy" alt="logo"  />
                <div className="mask"></div>
            </div>}

                <TopBar  lengthResto={lengthResto}  listBase={listeResto} />
                
                <Body cityLoad={finalCityLoad} distanceFilter={distanceFilter} resetSearchResto={fetchRestaurants} setShowAll={setShowAll} setLengthResto={setLengthResto}  listBase={listeResto} fetchResto={fetchResto} setCurrentLoc={setLocations} />


                <Suspense fallback={null}>
                    {
                        showAll === 1 ? 
                            <ShowAllCuisine close={funcClose}/>
                            :
                            showAll === 2 && <ShowAllType close={funcClose} />
                    }
                    {
                        connectionScreen ? <ConnectionScreen /> : undefined
                    }
                    {cantProximity ? <CantProximity setCantProximity={setCantProximity}/> : undefined}
                </Suspense>
                <Footer cityLoad={(finalCityLoad && finalCityLoad !== '') ? finalCityLoad : ''} listRestoLoad={(finalCityLoad && finalCityLoad !== '') ? listeResto : []} isHomePage={true}/>
                
           
             
        </div>
        </>
    )
}

export default HomeScreen